import script from "./EditDomainEventDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDomainEventDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditDomainEventDialog.vue?vue&type=style&index=0&id=73339291&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73339291"]])

export default __exports__